import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { getDigitPairsArray } from "../../utils";
import "./styles.scss";

const CodeButton = ({
  code,
  length,
  onClick,
  disabled
}) => {
  const codeParts = useMemo(() => getDigitPairsArray(code?.substring(0, length)), [code, length]);
  return /*#__PURE__*/React.createElement("button", {
    className: "mydpd-commodity-code-button",
    onClick: onClick,
    disabled: disabled
  }, codeParts.map((number, index) => /*#__PURE__*/React.createElement("span", {
    key: `${number}-${index}`,
    className: "mydpd-commodity-code-part"
  }, number)));
};

CodeButton.propTypes = {
  code: PropTypes.string,
  length: PropTypes.number,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
};
export default CodeButton;